export const OTInteractionCookie = 'OptanonAlertBoxClosed';
